import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions, Response, ResponseContentType } from '@angular//http';
import { User } from '../_models/index';
import 'rxjs/add/operator/toPromise';
import { AuthHttp } from 'angular2-jwt';
import { environment } from '../../environments/environment';

@Injectable()

export class PaymentServices {

    backendUrl: any;
    TOKEN: any;
    headers: any;
    options: any;
    secret: any;

    api = "/payment/"

    constructor(private http: AuthHttp) {
       
        this.backendUrl=window.location.origin
        if(!environment.production)
            this.backendUrl = environment.url;
        this.backendUrl+="/apis"
        
        this.secret = environment.secret;
    }


    getAllPlans(country) {
        return this.http.post(`${this.backendUrl}${this.api}get-plans`, country, this.jwt_new()).map((response: Response) => response.json());
    }

    checkCard(data){
        return this.http.post(`${this.backendUrl}${this.api}check-card`, data, this.jwt_new()).map((response: Response) => response.json());
    }


    subscribeUser(data){
        return this.http.post(`${this.backendUrl}${this.api}create`, data, this.jwt_new()).map((response: Response) => response.json());
    }

    createRfc(data){
        return this.http.post(`${this.backendUrl}${this.api}create-rfc`, data, this.jwt_new()).map((response: Response) => response.json());
    }

    checkPlanActivationStatus(data){
        return this.http.post(`${this.backendUrl}${this.api}status`, data, this.jwt_new()).map((response: Response) => response.json());
    }

    getStripeCustomer(customerId, country){
        return this.http.get(`${this.backendUrl}${this.api}get-customer/${customerId}/${country}`, this.jwt_new()).map((response: Response) => response.json());
    }

    getUsagesSummary(id, country){
        return this.http.get(`${this.backendUrl}${this.api}get-usages/${id}/${country}`, this.jwt_new()).map((response: Response) => response.json());
    }

    changePlan(data){
        return this.http.post(`${this.backendUrl}${this.api}change`, data, this.jwt_new()).map((response: Response) => response.json());
    }


    addPaymentMthod(data){
        return this.http.post(`${this.backendUrl}${this.api}add-method`, data, this.jwt_new()).map((response: Response) => response.json());
    }


    ChangeDefaultPaymentMthod(data){
        return this.http.post(`${this.backendUrl}${this.api}change-default-method`, data, this.jwt_new()).map((response: Response) => response.json());
    }

    updatePaymentMethod(data){
        return this.http.post(`${this.backendUrl}${this.api}update-method`, data, this.jwt_new()).map((response: Response) => response.json());
    }

    checkCouponCode(data){
        return this.http.post(`${this.backendUrl}${this.api}coupon`, data, this.jwt_new()).map((response: Response) => response.json());
    }

    activateFreePlan(data){
        return this.http.post(`${this.backendUrl}${this.api}activate_freeplan`, data, this.jwt_new()).map((response: Response) => response.json());
    }

    getBillingRole(){
        return this.http.get(`${this.backendUrl}${this.api}get_role`, this.jwt_new()).map((response: Response) => response.json());
    }

    getCurencyData(){
        return this.http.post(`${this.backendUrl}/getCurrencyData`, this.jwt_new()).map((response: Response) => response.json());
    }
    

    

    private jwt_new() {
        this.TOKEN = (localStorage.getItem('id_token') != undefined) ? localStorage.getItem('id_token') : localStorage.getItem('login_token');
        this.headers = new Headers({ 'Content-Type': 'application/json' });
        this.headers.append('Authorization', this.TOKEN)
        this.options = new RequestOptions({ headers: this.headers });
        return this.options;
    }

    private jwt() {
        // create authorization header with jwt token
        this.TOKEN = (localStorage.getItem('id_token') != undefined) ? localStorage.getItem('id_token') : localStorage.getItem('login_token');
        let headers = new Headers({ 'Authorization': this.TOKEN });
        return new RequestOptions({ headers: headers });
    }
}


// WEBPACK FOOTER //
// /var/www/html/foodbot_stage/web/src/app/_services/payment.services.ts